export default {
  model: {
    itemType: {
      notes: 'Claim item content type',
      message: 'Content type',
      values: {
        accommodation: {
          notes: 'Claim item type "Accommodation".',
          message: 'Accommodation',
        },
        allowance: {
          notes: 'Claim item type "Allowance".',
          message: 'Allowance',
        },
        import_duty: {
          notes: 'Claim item type "Import duty".',
          message: 'Import duty',
        },
        item: {
          notes: 'Claim item type "Part" (a.k.a. "Item").',
          message: 'Part',
        },
        labour: { notes: 'Claim item type "Labour".', message: 'Labour' },
        local_material: {
          notes: 'Claim item type "Local material".',
          message: 'Local material',
        },
        mileage: { notes: 'Claim item type "Mileage".', message: 'Mileage' },
        parts_freight_costs: {
          notes: 'Claim item type "Parts freight costs".',
          message: 'Parts freight costs',
        },
        sub_contractor: {
          notes: 'Claim item type "Sub contractor".',
          message: 'Sub contractor',
        },
        tickets: { notes: 'Claim item type "Tickets".', message: 'Tickets' },
        travel_hours: {
          notes: 'Claim item type "Travel hours".',
          message: 'Travel hours',
        },
        unit_transportation_costs: {
          notes: 'Claim item type "Unit transportation costs".',
          message: 'Unit transportation costs',
        },
        vat: { notes: 'Claim item type "VAT".', message: 'VAT' },
        workshop_material: {
          notes: 'Claim item type "Workshop material".',
          message: 'Workshop material',
        },
      },
    },
    itemNumber: {
      notes: 'Claim item part id',
      message: 'ID',
    },
    primaryCause: {
      notes: 'Claim item primary cause',
      message: 'Primary cause',
    },
    quantity: {
      notes: 'Claim item quantity',
      message: 'Quantity',
    },
    priceRate: {
      notes: 'Claim item price per unit',
      message: 'Price claimed per unit',
    },
    subTotal: {
      notes: 'Claim item subtotal',
      message: 'Subtotal',
    },
  },
  actions: {
    addRowButton: {
      notes: 'Button title for adding rows to a claim',
      message: 'Add row',
    },
    removeRowButton: {
      notes: 'Button title for removing a row from a claim',
      message: 'Remove',
    },
  },
  validations: {
    itemRowsMissingValidation: {
      notes: 'Validation error when there are no claim item rows.',
      message: 'At least one row is required',
    },
  },
  totals: {
    totalClaimed: {
      notes: 'Footer for total sum claimed for all rows',
      message: 'Total claimed',
    },
  },
};
